export default "/build/client/static/fonts/SoderbergSans-Medium.woff";